/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { AnyAction } from 'redux';
import { ReduxStateLoadable } from './index';


type Country = { code: string, name: string };
type Data = { countries: Country[] }
type State = ReduxStateLoadable<Data, Data>;
const defaultState: State = {
  data: {
    countries: []
  },
  loading: false,
  loaded: false,
  errored: false,
};


const common = (state: State = defaultState, action: AnyAction): State => {

  switch (action.type) {
    case actionTypes.LOADING_COMMON:
      return { ...state, loading: true, loaded: false, errored: false, };
    case actionTypes.ERROR_COMMON:
      return { ...state, loading: false, loaded: false, errored: true };
    case actionTypes.LOADED_COMMON:
      return {
        ...state,
        data: action.data,
        errored: false,
        loading: false,
        loaded: true,
      };
    default:
      return state;

  }

};

export default common;
